/**
 * Our opening hours, the same rule Leo's server uses (whatsapp-webhook/_logic.ts isWorkingTime): Monday to
 * Friday, 08:00 to 17:00 South African time, closed on public holidays (country_config.public_holidays).
 * Outside them Leo is on duty for everyone (Gary, 19 Oct).
 */
const TIME_ZONE = 'Africa/Johannesburg';
const WORK_DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'];
const WORK_START_HOUR = 8;
const WORK_END_HOUR = 17;

/** Open now? holidays holds dates as YYYY-MM-DD in South African time. */
export function isOpen(at: number, holidays: Set<string>): boolean {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: TIME_ZONE, weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23',
  }).formatToParts(new Date(at));
  const get = (t: string) => parts.find((p) => p.type === t)?.value ?? '';
  const hour = Number(get('hour'));
  return WORK_DAYS.includes(get('weekday')) && hour >= WORK_START_HOUR && hour < WORK_END_HOUR
    && !holidays.has(`${get('year')}-${get('month')}-${get('day')}`);
}
